import React, {FC} from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import {lazy} from '@aboutyou/lazy-imports';
import {ErrorBoundaryProps} from './ErrorView';

const ErrorView = lazy(() =>
  import('./ErrorView').then(mod => ({default: mod.ErrorView})),
);

/**
 * Creates a fallback component to be used in case of error breaking an app
 * caught by the App.
 *
 * @constructor
 */
export const ErrorBoundaryFallback: FC<ErrorBoundaryProps> = ({
  errorBoundaryTexts,
}) => {
  return <ErrorView errorBoundaryTexts={errorBoundaryTexts} />;
};
